import React, { useEffect } from 'react';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: (...args: unknown[]) => void;
  }
}
const PIXEL_ID = '26302402029436087';
const META_SCRIPT_ID = 'meta-pixel-script';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  queue: unknown[][];
};
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq = ((...args: unknown[]) => {
      fbq.queue.push(args);
    }) as MetaPixelFunction;
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    if (!document.getElementById(META_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = META_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
  }, []);
  return <noscript data-id="element-106" data-mp="ri4eb9t0dkww">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-107" data-mp="18fry35fazn6i" />
    </noscript>;
}